import { render } from "./EmptyState.vue?vue&type=template&id=0f4ffc70&scoped=true"
const script = {}

import "./EmptyState.vue?vue&type=style&index=0&id=0f4ffc70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4ffc70"]])

export default __exports__